import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { SLASH_HEADER_CONVERTER_TOKEN, SlashHeaderConverter } from './slash-header.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        slashHeaderFeature: {
          module: () => import('./slash-header.module').then((m) => m.SlashHeaderModule),
          cmsComponents: ['slashheader'],
        },
      }
    }),
    {
      provide: SLASH_HEADER_CONVERTER_TOKEN,
      useExisting: SlashHeaderConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        slashheader: SLASH_HEADER_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class SlashHeaderFeatureModule {}
